<template>
  <div>
    <Title title="Estados"
           subtitle="Revisa el estado de tus planificaciones"/>
    <el-form v-model="filter"
             :inline="true">
      <el-form-item>
        <el-input v-model="filter.tracing_code"
                  placeholder="SEGUIMIENTO O ID RUTA"
                  @keyup.enter.native="handleSearch"
                  clearable/>
      </el-form-item>
      <el-form-item>
        <el-select  v-model="filter.distribution_centers_id"
                    placeholder="CT"
                    style="width: 280px"
                    filterable
                    @change="changeCt"
                    multiple
                    no-match-text="No existen coincidencias"
                    no-data-text="Cargando..."
                    clearable>
          <el-option  v-for="ct in data.cts"
                      :key="ct.id"
                      :label="ct.name"
                      :value="ct.id"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="filter.enterprise_id"
                   placeholder="EMPRESA"
                   filterable
                   @change="changeEn"
                   no-match-text="No existen coincidencias"
                   no-data-text="Cargando..."
                   clearable>
          <el-option  v-for="enterprise in data.enterprises"
                      :key="enterprise.id"
                      :label="enterprise.name"
                      :value="enterprise.id"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button  v-if="filter.enterprise_id === ''&& !filter.distribution_centers_id.length > 0
                    && filter.tracing_code === ''"
                    class="default searchBttn"
                    @click="reLoad">
          <span v-if="!submitLoading" ><i class="el-icon-refresh"/>&nbsp;&nbsp;RECARGAR</span>
          <span v-else><i class="el-icon-loading"/>&nbsp;&nbsp;CARGANDO</span>
        </el-button>
        <el-button  class="default searchBttn"
                    v-else
                    @click="handleSearch">
          <i class="fa fa-search"/>&nbsp;&nbsp;BUSCAR
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button class="flat searchBttnC"
                   @click="cleanFilter">
          <i class="fas fa-broom"/>&nbsp;&nbsp;LIMPIAR
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button  class="flat searchBttnD"
                    :loading ="submitLoading"
                    @click="toggleRollback">
          <i v-if="!submitLoading" :class="lockIcon"/>
          &nbsp;&nbsp;ACTIVAR ELIMINAR
        </el-button>
      </el-form-item>
    </el-form>
    <div class="content">
      <!--<BaseLoadTruck v-show="loadTruck"/> -->
      <LoadingTruck :loading="loadTruck">
        <el-table :data="status"
                  size="mini"
                  tooltip-effect="dark">
          <div slot="empty"
                class="empty-table">
            <p>Sin datos</p>
          </div>
              <el-table-column  label="SEG"
                                align="left"
                                :min-width="50">
                <template slot-scope="scope">{{ scope.row.id }}</template>
              </el-table-column>
              <el-table-column  label="SOC"
                                align="left"
                                :min-width="50"
                                show-overflow-tooltip
                                prop="total_suborders"/>
              <el-table-column  label="RUTAS"
                                show-overflow-tooltip
                                align="left"
                                :min-width="50"
                                prop="total_routes"/>
              <el-table-column  label="ESTADO"
                                align="left"
                                :min-width="120">
                <template slot-scope="scope">
                  <el-popover trigger="hover"
                              placement="top-start"
                              title="Estado">
                    <div v-if="scope.row.code === 6 && scope.row.total_routes >0"
                         style="text-align: center; margin: 0">
                      <p style="font-size: 12px;">{{scope.row.status | splitResp }}</p>
                      <el-button size="mini"
                                 type="text"
                                 @click="goRoutes(scope.row.id)">Ver ruta
                      </el-button>
                      <el-button type="text"
                                 size="mini"
                                 @click="goAdminRoutes(scope.row.id)">
                        Administrar Ruta
                      </el-button>
                    </div>
                    <p v-else>{{ scope.row.status}}</p>
                    <div slot="reference">
                      <el-tag size="small"
                              :style="popoverStype(scope.row.code,scope.row.status)"
                              :type="'success'">
                        {{ scope.row.status | splitText }}
                      </el-tag>
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column  label="CT/CD/CTT"
                                align="left"
                                show-overflow-tooltip
                                :min-width="80"
                                prop="distribution_centers_name"/>
              <el-table-column  label="USUARIO"
                                :formatter="upUser"
                                align="left"
                                show-overflow-tooltip
                                :min-width="120"
                                prop="email"/>
              <el-table-column  label="FECHA"
                                :min-width="70"
                                align="left">
                <template slot-scope="scope"
                          align="center">
                  {{formatDate(scope.row.created_at)}}
                </template>
              </el-table-column>
              <el-table-column label="EDITAR"
                               align="center"
                               :min-width="50">
                <template slot-scope="scope">
                  <el-button :disabled="!isFinished(scope.row.code) || !(scope.row.total_routes >0)"
                             type="text"
                             icon="el-icon-edit"
                             class="rowIcon"
                             :style="isFinished(scope.row.code) && (scope.row.total_routes >0)?
                                  'font-size: 20px;': 'font-size: 20px; width:0; margin-left:-20px'"
                             @click="editPlanning(scope.row.id)">
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="GRILLA"
                               :min-width="50"
                               align="center">
                <template slot-scope="scope">
                  <el-button  v-if="scope.row.total_routes >0"
                              style="background:transparent;border-color:transparent;padding: 2px;"
                              size="mini"
                              type="primary"
                              @click="getPreReport(scope.row.id)">
                    <i class="fas fa-file-download" style="color: #AAD500; font-size: 20px;"></i>
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="ELIMINAR"
                               :min-width="50"
                               align="center">
                <template slot-scope="scope">
                  <el-button  v-if="isFinished(scope.row.code)"
                              style="background:transparent; border-color: transparent; padding: 0"
                              size="mini"
                              type="primary"
                              @click="rollback(scope.row.id)">
                    <span class="fa-stack fa-1x">
                      <i class="fas fa-backspace fa-stack-2x"
                         v-bind:style="{color:rollbackMode?'#d54200':'rgba(213,70,0,0.49)'}"></i>
                      <i v-if="!rollbackMode" class="fas fa-lock fa-stack-1x"
                         style="color: #d5c500;top:8px;left:12px;"></i>
                    </span>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
        <el-row>
          <el-col :span="22" :offset="1" class="toolbar">
            <el-pagination layout="total, prev, pager, next"
                           @current-change="handleCurrentChange"
                           :page-size="10"
                           :total="totalSize"
                           v-show="totalSize > 0"
                           style="float:right;">
            </el-pagination>
          </el-col>
        </el-row>
      </LoadingTruck>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { saveAs } from 'file-saver';
import { apiRequest, getReport } from '../../backend/vue-axios/axios';
import Title from '../components/base/Title.vue';
import LoadingTruck from '../components/loading/Truck.vue';
import { trackBusinessFlow } from '@/observability/datadogRum';

export default {
  name: 'PlanningStatus',
  components: {
    Title,
    LoadingTruck,
  },
  data() {
    return {
      status: [],
      rollbackMode: false,
      totalSize: 0,
      loading: false,
      submitLoading: false,
      tracing_code: null,
      loadTruck: false,
      data: {
        enterprises: [],
        cts: [],
      },
      filter: {
        tracing_code: '',
        enterprise_id: '',
        distribution_centers_id: [],
        limit: 10,
        offset: 0,
      },
      tfDc: false,
      ftEn: false,
    };
  },
  filters: {
    splitText(text) {
      return text.split(',', 1).join();
    },
    splitResp(t) {
      const a = t.split(',', 2);
      return a[1];
    },
  },
  methods: {
    popoverStype(code, status) {
      switch (code) {
        case 7:
          return 'background-color: #AAD500; color: white; opacity: 0.8;';
        case 6:
          if (status.length > 23) {
            return 'background-color: #E6A23C; color: white; opacity: 0.8;';
          }
          return 'background-color: #AAD500; color: white; opacity: 0.8;';
        case 5:
          return 'background-color: #00e676; color: #333333;  opacity: 0.7;';
        case 4:
          return 'background-color: #1de9b6; color: #333333;  opacity: 0.7;';
        case 3:
          return 'background-color: #00e5ff; color: #333333;  opacity: 0.7;';
        case 2:
          return 'background-color: #f4511e; color: white; opacity: 0.7;';
        case 1:
        case 0:
          return 'background-color: #00b0ff; color: #333333;  opacity: 0.8;';
        default:
          return 'background-color: #2979ff; color: white;  opacity: 0.8;';
      }
    },
    changeCt(a) {
      this.tfDc = a.length > 0 ? 'true' : 'false';
    },
    changeEn(a) {
      this.tfEn = a !== '' ? 'true' : 'false';
    },
    isFinished(code) {
      if (code === 6 || code === 2) {
        return true;
      }
      return false;
    },
    cleanFilter() {
      this.$router.replace({ query: null });
      this.filter.enterprise_id = '';
      this.filter.distribution_centers_id = [];
      this.filter.tracing_code = '';
    },
    getDistributionCenters() {
      apiRequest({
        module: 'planning',
        service: 'distribution_centers',
        params: { limit: 1000 },
      }).then((data) => {
        this.data.cts = data.data;
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'No se pudo cargar los CT',
        });
      });
    },
    getEnterprises() {
      apiRequest({
        module: 'planning',
        service: 'enterprises',
        params: {
          limit: 6000,
        },
      }).then((data) => {
        this.data.enterprises = data.data;
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar empresas',
        });
      });
    },
    handleSearch() {
      this.loadTruck = true;
      const querys = {};
      this.$router.replace({ query: null });
      if (this.filter.distribution_centers_id.length > 0 && this.filter.enterprise_id === '') {
        querys.distribution_centers_id = this.filter.distribution_centers_id;
      }
      if (this.filter.enterprise_id !== '' && this.filter.distribution_centers_id.length === 0) {
        querys.enterprise_id = this.filter.enterprise_id;
      }
      if (this.filter.enterprise_id !== '' && this.filter.distribution_centers_id.length > 0) {
        querys.enterprise_id = this.filter.enterprise_id;
        querys.distribution_centers_id = this.filter.distribution_centers_id;
      }
      this.$router.push({
        name: 'Status',
        query: querys,
      });
      this.getStatus({
        limit: this.filter.limit,
        offset: this.filter.offset,
        distribution_centers_id: this.filter.distribution_centers_id,
        enterprise_id: this.filter.enterprise_id,
        id: this.filter.tracing_code,
      });
    },
    reLoad() {
      this.loadTruck = true;
      this.cleanFilter();
      this.getStatus({
        limit: this.filter.limit,
        offset: this.filter.offset,
        distribution_centers_id: this.filter.distribution_centers_id,
        enterprise_id: this.filter.enterprise_id,
        id: this.filter.tracing_code,
      });
    },
    getStatus(parameters = {}) {
      this.submitLoading = true;
      apiRequest(
        {
          module: 'planning',
          service: 'status_planning',
          params: parameters,
        },
      ).then((res) => {
        this.status = res.data;
        this.totalSize = parseInt(res.headers['x-total-count'], 10);
        this.loadTruck = false;
        this.submitLoading = false;
      }).catch((err) => {
        this.totalSize = 0;
        this.loadTruck = false;
        this.submitLoading = false;
        this.status = [];
        if (err.response.status === 404) {
          this.$message({
            message: 'No se encontraron planificaciones con los filtros entregados. Cod:404',
            type: 'warning',
          });
        } else {
          this.$notify({
            type: 'error',
            title: 'Error',
            message: 'Problemas al cargar estados de Planificaciones',
          });
        }
      });
    },
    goAdminRoutes(id) {
      this.tracing_code = id;
      trackBusinessFlow({
        module: 'planning',
        flow: 'route_editing',
        action: 'admin_routes_opened',
        status: 'success',
        context: {
          tracing_id: id,
          source: 'planning_status',
          distribution_center_count: this.filter.distribution_centers_id.length,
          distribution_center_scope: this.filter.distribution_centers_id.length === 0 ? 'none' : this.filter.distribution_centers_id.length === 1 ? 'single' : 'multiple',
          has_enterprise_filter: this.filter.enterprise_id !== '',
        },
      });
      this.$router.push({
        name: 'modify',
        params: { tracing_code: id },
        query: { tracing_code: id },
      });
    },
    goRoutes(id) {
      this.tracing_code = id;
      this.$router.push({
        name: 'Routes',
        query: { tracing_code: id },
        params: { tracing_code: id },
      });
      this.$message({
        message: `Cargando rutas Seguimiento ${id}, espera un momento por favor`,
        duration: 10000,
        showClose: true,
      });
    },
    toggleRollback() {
      this.rollbackMode = !this.rollbackMode;
    },
    rollback(_id) {
      if (this.rollbackMode) {
        this.$confirm('¿Seguro que quieres eliminar la ruta?', 'Confirmación', {
          confirmButtonText: 'Si',
          cancelButtonText: 'No',
          type: 'warning',
        }).then(() => {
          this.loadTruck = true;
          this.submitLoading = true;
          apiRequest({
            module: 'planning',
            service: 'planning_rollback',
            pathparam: {
              id: _id,
            },
          }).then(() => {
            this.getStatus();
          }).catch((err) => {
            if (err.response.status === 404) {
              this.$notify({
                type: 'error',
                title: 'Error',
                message: 'Planificación no encontrada',
              });
            }
            this.getStatus();
            /*  */
          });
        }).catch(() => {});
      }
    },
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY');
    },
    formatter(status) {
      return `${status.substr(0, 25)}`;
    },
    upUser(data) {
      return data.email.toUpperCase();
    },
    getLimitPage(page) {
      return ((page - 1) * 10);
    },
    handleCurrentChange(newPage) {
      this.loadTruck = true;
      this.getStatus({
        limit: this.filter.limit,
        enterprise_id: this.filter.enterprise_id,
        id: this.filter.tracing_code,
        distribution_centers_id: this.filter.distribution_centers_id,
        offset: this.getLimitPage(newPage),
      });
    },
    editPlanning(rowId) {
      trackBusinessFlow({
        module: 'planning',
        flow: 'route_editing',
        action: 'edit_view_opened',
        status: 'success',
        context: {
          tracing_id: rowId,
          source: 'planning_status',
          distribution_center_count: this.filter.distribution_centers_id.length,
          distribution_center_scope: this.filter.distribution_centers_id.length === 0 ? 'none' : this.filter.distribution_centers_id.length === 1 ? 'single' : 'multiple',
          has_enterprise_filter: this.filter.enterprise_id !== '',
        },
      });
      const parameter = { idTracing: `${rowId}` };
      if (this.filter.distribution_centers_id.length > 0 && this.filter.enterprise_id === '') {
        parameter.distribution_centers_id = this.filter.distribution_centers_id;
        parameter.v = 1;
      }
      if (this.filter.enterprise_id !== '' && this.filter.distribution_centers_id.length === 0) {
        parameter.enterprise_id = this.filter.enterprise_id;
        parameter.v = 2;
      }
      if (this.filter.enterprise_id !== '' && this.filter.distribution_centers_id.length > 0) {
        parameter.enterprise_id = this.filter.enterprise_id;
        parameter.distribution_centers_id = this.filter.distribution_centers_id;
        parameter.v = 3;
      }
      if (this.filter.enterprise_id === '' && this.filter.distribution_centers_id.length === 0) {
        parameter.v = 0;
      }
      this.$router.push({
        name: 'editMultiple',
        params: parameter,
      });
    },
    getPreReport(id) {
      getReport({
        module: 'planning',
        service: 'get_pre_report',
        pathparam: id,
        // eslint-disable-next-line
      }).then((res) => {
        if (res.status === 200) {
          return res.blob();
        }
      }).then((blob) => {
        const headers = {
          cache: 'no-cache',
        };
        saveAs(blob, `pregrilla-planificacion-${id}.xlsx`, headers);
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al obtener reporte',
        });
      });
    },
  },
  created() {
    this.loadTruck = true;
    // eslint-disable-next-line
    if (this.$route.query.distribution_centers_id === undefined) {
      this.filter.distribution_centers_id = [];
    }
    if (this.$route.query.enterprise_id === undefined) {
      this.filter.enterprise_id = '';
    }
    if (this.$route.params.v === 1) {
      this.filter.distribution_centers_id = this.$route.query.distribution_centers_id;
    }
    if (this.$route.params.v === 2) {
      this.filter.enterprise_id = this.$route.query.enterprise_id;
    }
    if (this.$route.params.v === 3) {
      this.filter.enterprise_id = this.$route.query.enterprise_id;
      this.filter.distribution_centers_id = this.$route.query.distribution_centers_id;
    }
    if (this.$route.params.v === 0) {
      this.filter.enterprise_id = '';
      this.filter.distribution_centers_id = [];
    }
    this.getDistributionCenters();
    this.getEnterprises();
    this.getStatus(this.filter);
  },
  computed: {
    lockIcon() {
      return (this.rollbackMode ? 'fas fa-lock-open' : 'fas fa-lock');
    },
  },
};
</script>
<style lang="scss" scoped>
  $base-color: #c6538c;
  .content {
    margin-bottom: 30px;
  }
  .el-form {
    text-align: left;
  }
  .searchBttn {
    height: 40px;
  }
  .searchBttnD {
    height: 40px;
  }
  .searchBttnC {
    height: 40px;
  }
  .empty-table { line-height: 20; }
</style>
